module.exports = __webpack_public_path__ + "static/media/morning-slot-icon.bf5ac4fa.svg";